var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplorer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5716 0H4.52381C2.02538 0 0 2.02538 0 4.52381V13.5714C0 16.0699 2.02538 18.0952 4.52381 18.0952H13.5716C16.07 18.0952 18.0954 16.0699 18.0954 13.5714V4.52381C18.0954 2.02538 16.07 0 13.5716 0Z",
    fill: "url(#paint0_linear_32665_27425)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75167 11.6127C6.58983 11.6127 4.83105 9.85389 4.83105 7.69207C4.83105 5.53024 6.58983 3.77148 8.75167 3.77148C10.9135 3.77148 12.6723 5.53024 12.6723 7.69207C12.6723 9.85389 10.9135 11.6127 8.75167 11.6127ZM8.75167 5.40305C7.48953 5.40305 6.46263 6.42994 6.46263 7.69207C6.46263 8.95419 7.48953 9.98108 8.75167 9.98108C10.0138 9.98108 11.0407 8.95419 11.0407 7.69207C11.0407 6.42994 10.0138 5.40305 8.75167 5.40305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72978 14.4382C7.14382 14.4382 5.65033 13.8231 4.52441 12.7062L5.67337 11.5479C6.49165 12.3596 7.57709 12.8066 8.72978 12.8066C9.88247 12.8066 11.0015 12.3461 11.8242 11.5098L12.9873 12.6539C11.8556 13.8044 10.3435 14.4382 8.72978 14.4382Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75067 8.62633C9.26665 8.62633 9.68494 8.20805 9.68494 7.69207C9.68494 7.17609 9.26665 6.75781 8.75067 6.75781C8.23469 6.75781 7.81641 7.17609 7.81641 7.69207C7.81641 8.20805 8.23469 8.62633 8.75067 8.62633Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32665_27425",
    x1: 18.0954,
    y1: 9.04762,
    x2: 0,
    y2: 9.04762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBD938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04AF6D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/explorer.4cfa86888e52265500824703af1db732.svg";
export { ForwardRef as ReactComponent };